import React from 'react';
import styles from './Skeletons.module.css';
import ButtonSkeleton from './ButtonSkeleton';

const SkeletonLoader = () => {
  return (
    <div className={styles.skeletonLoader}>
   

      {/* Repeated Skeleton Sections for Form */}
      <div className={styles.skeletonFormContent}></div>
      <div className={styles.skeletonFormContent}></div>
      <div className={styles.skeletonFormContent}></div>
      <div className={styles.skeletonFormContent}></div>

      {/* Skeleton for Buttons */}


{/*       
      <div className={styles.skeletonButton}>
        <ButtonSkeleton/>
        <ButtonSkeleton/>
      </div> */}
      
    </div>
  );
};

export default SkeletonLoader;

